import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

import LoginView from "@/views/LoginView.vue";
import LessonView from "@/views/LessonView.vue";
import MainView from '@/views/MainView.vue';
import SmsStateView from '@/views/SmsStateView.vue';

import store from "@/store"; // 引入 Vuex Store

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView,
        meta: {title: '天琴湾钢琴'},
    },
    {
        path: "/main",
        name: "main",
        component: MainView,
        meta: {requiresAuth: true, title: '课程列表'},
    },
    {
        // ★ 家长链接的落点：只认分享码，地址栏里不出现课程 ID。
        //   **不能加 requiresAuth** —— 家长没有账号，加了守卫所有链接都打不开。
        //
        //   注意名字：家长看到的是 /share/xxx，而它背后调的接口在
        //   /api/lesson-view/xxx —— 两个名字是故意分开的，别看着不一样就去"对齐"。
        path: "/share/:token",
        name: "share",
        component: LessonView,
        meta: {title: '课程反馈'},
    },
    {
        // 学生从课程列表点进来走这条，按 ID 取数据。
        // 这里**故意不加守卫**：未登录时由 LessonView 自己判断并显示
        // "链接已更新"提示页 —— 直接甩一个登录页，家长会一头雾水。
        path: "/lesson/:id",
        name: "lesson",
        component: LessonView,
        meta: {title: '课程反馈'},
    },
    {
        // 短信发送情况：给管理员排查"有没有发出去 / 是不是欠费被拒"用的。
        //
        // **首页没有入口**，地址只写在 README 里。
        //
        // 也**故意不加 requiresAuth**：网页前端只有学生登录，而这个页面是给
        // 管理员看的 —— 加了守卫就得先找一个学生账号登录才能看，本末倒置。
        // 接口那边同样是公开的，靠"地址不公开 + 服务端脱敏"兜着：
        // 姓名只留姓、手机号隐中间四位，完整值不出服务器。
        path: "/sms-state",
        name: "sms-state",
        component: SmsStateView,
        meta: {title: '短信发送情况'},
    },
    {
        path: "/login",
        name: "login",
        component: LoginView,
        meta: {title: '学生登录'},
    },
    {
        // 兜底：管理端已下线（改由 App 管理），老地址 /manage、/manage-login
        // 之类一律回首页 —— 否则会落到一片空白，让人以为网站坏了
        path: "*",
        redirect: "/",
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
    const token = store.getters.token;

    // 需要登录的页面（目前只有 /main）
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            next({ name: "login" });
            return;
        }
    }

    next();
});

// 全局后置钩子
router.afterEach((to) => {
    // 从路由的 meta 中获取标题
    document.title = to.meta.title || '慧钢琴';
});

export default router;
